import { reactive } from 'vue'
import { apiFetch } from './api'

export interface Pendencia {
  id: string
  projectId: string
  projectName: string
  responsavel: string
  shortDescription: string
  fullDescription: string
  photo: string
  taskId: string
  taskTitle: string
  createdAt: string
  createdBy: string
  updatedAt: string
}

interface PendenciasState {
  items: Pendencia[]
  loading: boolean
  currentProjectId: string
}

const state = reactive<PendenciasState>({
  items: [],
  loading: false,
  currentProjectId: ''
})

const load = async (projectId: string) => {
  state.loading = true
  state.currentProjectId = projectId
  try {
    const rows = await apiFetch<Pendencia[]>(`/projects/${encodeURIComponent(projectId)}/pendencias`)
    state.items = rows
  } finally {
    state.loading = false
  }
}

const create = async (projectId: string, data: {
  responsavel: string
  shortDescription: string
  fullDescription: string
  photo: string
  taskId: string
  taskTitle: string
  projectName: string
}): Promise<string> => {
  const result = await apiFetch<{ id: string }>(`/projects/${encodeURIComponent(projectId)}/pendencias`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
  await load(projectId)
  return result.id
}

const update = async (projectId: string, id: string, data: {
  responsavel: string
  shortDescription: string
  fullDescription: string
  photo: string
  taskId: string
  taskTitle: string
}) => {
  await apiFetch(`/pendencias/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
  await load(projectId)
}

const remove = async (projectId: string, id: string) => {
  await apiFetch(`/pendencias/${encodeURIComponent(id)}`, { method: 'DELETE' })
  state.items = state.items.filter(p => p.id !== id)
}

export const pendenciasStore = { state, load, create, update, remove }
